import { HttpClient, HttpContext, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, catchError, throwError } from 'rxjs';

import { Microservices } from '../constants/pol.enums';
import { REQUIRES_DELEGATED_ACCESS_TOKEN } from '../interceptors/auth-token.interceptor';
import { BlobDocumentResponse } from '../models/global.model';

@Injectable()
export class POLDocumentService {
  window = window as any;
  unsubscribe = new Subject();

  constructor(private httpClient: HttpClient) {}

  public getBlobContentForDocuments(documentUrl: string, document?: any, docFromOnPrem?: boolean): Subject<BlobDocumentResponse> {
    const subject$ = new Subject<BlobDocumentResponse>();
    const documentApiUrl = this.getDocumentApiUrl(documentUrl, document, docFromOnPrem);
    this.httpClient.get(documentApiUrl, { responseType: 'blob' }).subscribe(
      (blobContent) => {
        const blobObj = new Blob([blobContent], { type: 'application/pdf' });
        const navigator = (window.navigator as any).msSaveOrOpenBlob;
        if (navigator) {
          subject$.next({
            documentBlob: blobObj,
            fileName: documentUrl,
            isMSIE: true
          });
        } else {
          subject$.next({
            documentUrl: URL.createObjectURL(blobObj),
            fileName: documentUrl,
            isMSIE: false
          });
        }
      },
      (er) => subject$.error(er)
    );
    return subject$;
  }

  getDocumentApiUrl = (documentUrl: string, document?: any, docFromOnPrem?: boolean) => {
    if (document && document.name) {
      return `${Microservices.Documents}/documents/${documentUrl}/${document.name}`;
    } else if (docFromOnPrem) {
      return `${Microservices.Documents}/Documents/PortalDocuments?filePath=${documentUrl}`;
    } else {
      return `${Microservices.Documents}/blobDocument?fileName=${documentUrl}`;;
    }
  };

  public getClarityIdCard(subscriberId: string): Observable<Blob> {
    const getIdCardApiUrl = `${Microservices.ClarityIdCard}/idcards/${subscriberId}/pdf/both`;
    const options = {
      responseType: 'blob' as 'blob',
      context: new HttpContext().set(REQUIRES_DELEGATED_ACCESS_TOKEN, true)
    };

    return this.httpClient.get(getIdCardApiUrl, options).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error fectching member ID card: ', error);
        return throwError(error);
      })
    );
  }

  getCarePdfDocuments(memberId: string, src: string, documentUrl: string): Subject<any> {
    const subject$ = new Subject<any>();
    const url = `${Microservices.ProviderOnline}/Documents/${memberId}?src=${src}&documentUrl=${documentUrl}`;
    const options: any = {
      context: new HttpContext().set(REQUIRES_DELEGATED_ACCESS_TOKEN, true),
      responseType: 'blob'
    };
    this.httpClient.get(url, options).subscribe(
      (blobContent) => {
        const blobObj = new Blob([blobContent], { type: 'application/pdf' });
        const navigator = (window.navigator as any).msSaveOrOpenBlob;
        if (navigator) {
          subject$.next({
            documentBlob: blobObj,
            fileName: documentUrl,
            isMSIE: true
          });
        } else {
          subject$.next({
            documentUrl: URL.createObjectURL(blobObj),
            fileName: documentUrl,
            isMSIE: false
          });
        }
      },
      (er) => subject$.error(er)
    );
    return subject$;
  }
}
